import type { LiveInputReceipt, LiveVoiceInput } from "./live-voice-input";
import { LiveInputError } from "./live-voice-input";
import { createSpaceRpc } from "./rpc";

/** Fresh input uses the ordinary guarded chat path and its durable send receipt.
 * Свіжий ввід використовує захищений шлях чату та його збережену квитанцію. */
export function sendLiveVoiceInput(
  input: LiveVoiceInput,
  scope: string,
): Promise<LiveInputReceipt> {
  let identity: unknown;
  try {
    identity = JSON.parse(scope);
  } catch {
    identity = null;
  }
  if (
    !Array.isArray(identity) ||
    identity.length !== 3 ||
    identity.some((value) => typeof value !== "string" || !value) ||
    identity[0] !== globalThis.location?.origin
  )
    throw new LiveInputError(
      "paused",
      "Voice input session changed / Сесія голосового вводу змінилася",
    );
  const client = createSpaceRpc(input.spaceId);
  const target = {
    ...input.target,
    callId: input.callId,
    utteranceId: input.utteranceId,
    expectedUserId: identity[1],
    expectedSessionId: identity[2],
  };
  return input.audioBase64 !== undefined
    ? client.live.audioInput({
        ...target,
        audioBase64: input.audioBase64,
        mimeType: input.mimeType,
      })
    : client.live.input({ ...target, text: input.text });
}
